import { QRButtonView, } from "./QRButtonView.tsx";

export function QRButtonModerator() {
  return (
    <QRButtonView showButton={true} />
  );
}
